<form #closeForm="ngForm" (ngSubmit)="close()" novalidate>
  <h2 mat-dialog-title>Approve request for: <strong *ngIf="approval?.value">{{ approval.approvalColumn | titlecase }} → {{ approval.value }} </strong>
    <strong *ngIf="!approval?.value">{{ approval.approvalColumn | titlecase }} </strong>
  </h2>
  <mat-dialog-content>
    <div class="pairs">
      <div class="row" *ngIf="approval.recipient">
        <span class="label">Recipient:</span>
        <span class="value">{{ approval.recipient!.enisNumber }}</span>
        <span class="flex">{{ approval.recipient.firstName || "" }} {{ approval.recipient.lastName || "" }}</span>
      </div>
    </div>

    <!-- Display requested priorities for priority requests -->
    <div *ngIf="approval.approvalColumn === 'priority' && (approval.requestedAcceptableHla || approval.requestedAcceptableBloodTypes)" class="requested-priorities">
      <h3>Requested Additional Privileges:</h3>
      <div *ngIf="approval.requestedAcceptableHla" class="privilege-item">
        <span class="label">Delisted Unacceptables:</span>
        <span class="value">{{ approval.requestedAcceptableHla }}</span>
      </div>
      <div *ngIf="approval.requestedAcceptableBloodTypes" class="privilege-item">
        <span class="label">Acceptable Blood Types:</span>
        <span class="value">{{ approval.requestedAcceptableBloodTypes }}</span>
      </div>
    </div>

    <!-- Optional approval comment field -->
    <div class="approval-comment-section">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Approval Comment (optional)</mat-label>
        <textarea matInput [(ngModel)]="approvalComment" name="approvalComment" rows="3" placeholder="Add any comments or notes about this approval"></textarea>
      </mat-form-field>
    </div>

    <ng-template #willclose>
      <i>Are you sure you want to deny this request?</i>
    </ng-template>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="spacer"></div>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button type="submit" [disabled]="!closeForm.valid">Approve</button>
  </mat-dialog-actions>
</form>
